
window.__VUE_OPTIONS_API__ = true;

window.__VUE_PROD_DEVTOOLS__ = false;

import { createApp } from 'vue';

import { createRouter, createWebHistory } from 'vue-router';

import App from './app.vue';

import Splash from './views/splash.vue';

import Activities from './views/activities.vue';

import Activity1 from './views/activity-1.vue';

import Activity1Intro from './views/activity-1-intro.vue';

import Activity1Photo1 from './views/activity-1-photo-1.vue';

import Activity1Photo2 from './views/activity-1-photo-2.vue';

import Activity1Photo3 from './views/activity-1-photo-3.vue';

import Activity1Photo4 from './views/activity-1-photo-4.vue';

import Activity1Review from './views/activity-1-review.vue';

import Activity1Completed from './views/activity-1-completed.vue';

import Activity2 from './views/activity-2.vue';

import Activity2Intro from './views/activity-2-intro.vue';

import Activity2Part1 from './views/activity-2-part-1.vue';

import Activity2Part2 from './views/activity-2-part-2.vue';

import Activity2Part3 from './views/activity-2-part-3.vue';

import Activity2Part4 from './views/activity-2-part-4.vue';

import Activity2Part5A from './views/activity-2-part-5-a.vue';

import Activity2Part5B from './views/activity-2-part-5-b.vue';

import Activity2Part6 from './views/activity-2-part-6.vue';

import Activity2Part7 from './views/activity-2-part-7.vue';

import Activity2Review from './views/activity-2-review.vue';

import Activity2Completed from './views/activity-2-completed.vue';

import Activity3 from './views/activity-3.vue';

import Activity3Intro from './views/activity-3-intro.vue';

import Activity3Part1 from './views/activity-3-part-1.vue';

import Activity3Part2Step1 from './views/activity-3-part-2-step-1.vue';

import Activity3Part2Step2 from './views/activity-3-part-2-step-2.vue';

import Activity3Part2Step3 from './views/activity-3-part-2-step-3.vue';

import Activity3Review from './views/activity-3-review.vue';

import Activity3Completed from './views/activity-3-completed.vue';

import Activity4 from './views/activity-4.vue';

import Activity4Intro from './views/activity-4-intro.vue';

import Activity4Part1 from './views/activity-4-part-1.vue';

import Activity4Part2Exercise from './views/activity-4-part-2-exercise.vue';

import Activity4Review from './views/activity-4-review.vue';

import Activity4Completed from './views/activity-4-completed.vue';

import Activity5 from './views/activity-5.vue';

import Activity5Intro from './views/activity-5-intro.vue';

import Activity5Step1 from './views/activity-5-step-1.vue';

import Activity5Step2 from './views/activity-5-step-2.vue';

import Activity5Step3 from './views/activity-5-step-3.vue';

import Activity5Step4 from './views/activity-5-step-4.vue';

import Activity5Preview from './views/activity-5-preview.vue';

import Activity5Completed from './views/activity-5-completed.vue';

const app = createApp( App );

const router = createRouter( {
  
  history: createWebHistory(),
  
  scrollBehavior ( to ) {

    if ( to.hash ) return {
      
      el: to.hash,
      
      behavior: 'smooth',

      top: 180
    
    };

  },

  routes: [ {
    
    path: '/',

    component: Splash,

    meta: { title: 'Welcome' }

  }, {

    path: '/activities',

    component: Activities,

    meta: { title: 'Activities' }

  }, {

    path: '/activity/1',

    component: Activity1,

    redirect: '/activity/1/intro',

    children: [ {

      path: '/activity/1/intro',

      component: Activity1Intro,

      meta: { title: 'Activity 1 - Introduction' }

    }, {

      path: '/activity/1/photo/1',

      component: Activity1Photo1,

      meta: { title: 'Activity 1 - Photo 1' }

    }, {

      path: '/activity/1/photo/2',

      component: Activity1Photo2,

      meta: { title: 'Activity 1 - Photo 2' }

    }, {

      path: '/activity/1/photo/3',

      component: Activity1Photo3,

      meta: { title: 'Activity 1 - Photo 3' }

    }, {

      path: '/activity/1/photo/4',

      component: Activity1Photo4,

      meta: { title: 'Activity 1 - Photo 4' }

    }, {

      path: '/activity/1/review',

      component: Activity1Review,

      meta: { title: 'Activity 1 - Review' }

    }, {

      path: '/activity/1/completed',

      component: Activity1Completed,

      meta: { title: 'Activity 1 - Completed' }
      
    } ]

  }, {

    path: '/activity/2',

    component: Activity2,

    redirect: '/activity/2/intro',

    children: [ {

      path: '/activity/2/intro',

      component: Activity2Intro,

      meta: { title: 'Activity 2 - Introduction' }

    }, {

      path: '/activity/2/part/1',

      component: Activity2Part1,

      meta: { title: 'Activity 2 - Part 1' }

    }, {

      path: '/activity/2/part/2',

      component: Activity2Part2,

      meta: { title: 'Activity 2 - Part 2' }

    }, {

      path: '/activity/2/part/3',

      component: Activity2Part3,

      meta: { title: 'Activity 2 - Part 3' }

    }, {

      path: '/activity/2/part/4',

      component: Activity2Part4,

      meta: { title: 'Activity 2 - Part 4' }

    }, {

      path: '/activity/2/part/5',

      redirect: '/activity/2/part/5/a'

    }, {

      path: '/activity/2/part/5/a',

      component: Activity2Part5A,

      meta: { title: 'Activity 2 - Part 5a' }

    }, {

      path: '/activity/2/part/5/b',

      component: Activity2Part5B,

      meta: { title: 'Activity 2 - Part 5b' }

    }, {

      path: '/activity/2/part/6',

      component: Activity2Part6,

      meta: { title: 'Activity 2 - Part 6' }

    }, {

      path: '/activity/2/part/7',

      component: Activity2Part7,

      meta: { title: 'Activity 2 - Part 7' }

    }, {

      path: '/activity/2/review',

      component: Activity2Review,

      meta: { title: 'Activity 2 - Review' }
    }, {

      path: '/activity/2/completed',

      component: Activity2Completed,

      meta: { title: 'Activity 2 - Completed' }

    } ]

  }, {

    path: '/activity/3',

    component: Activity3,

    redirect: '/activity/3/intro',

    children: [ {

      path: '/activity/3/intro',

      component: Activity3Intro,

      meta: { title: 'Activity 3 - Introduction' }

    }, {

      path: '/activity/3/part/1',

      component: Activity3Part1,

      meta: { title: 'Activity 3 - Part 1' }
      
    }, {

      path: '/activity/3/part/2',

      redirect: '/activity/3/part/2/step/1'

    }, {

      path: '/activity/3/part/2/step/1',

      component: Activity3Part2Step1,

      meta: { title: 'Activity 3 - Part 2 - Step 1' }

    }, {

      path: '/activity/3/part/2/step/2',

      component: Activity3Part2Step2,

      meta: { title: 'Activity 3 - Part 2 - Step 2' }
    }, {

      path: '/activity/3/part/2/step/3',

      component: Activity3Part2Step3,

      meta: { title: 'Activity 3 - Part 2 - Step 3' }

    }, {

      path: '/activity/3/review',

      component: Activity3Review,

      meta: { title: 'Activity 3 - Review' }

    }, {

      path: '/activity/3/completed',

      component: Activity3Completed,

      meta: { title: 'Activity 3 - Completed' }

    } ]

  }, {

    path: '/activity/4',

    component: Activity4,

    redirect: '/activity/4/intro',

    children: [ {

      path: '/activity/4/intro',

      component: Activity4Intro,

      meta: { title: 'Activity 4 - Introduction' }

    }, {
      
      path: '/activity/4/part/1',

      component: Activity4Part1,

      meta: { title: 'Activity 4 - Part 1' }

    }, {
      
      path: '/activity/4/part/2',

      redirect: '/activity/4/part/2/exercise/1'

    }, {
      
      path: '/activity/4/part/2/exercise/:id',

      component: Activity4Part2Exercise,

      meta: { title: 'Activity 4 - Part 2 - Exercises' },

      props: route => ( { id: Math.min( Math.max( parseInt( route.params.id ) || 1, 1 ), 3 ) } )

    }, {

      path: '/activity/4/review',

      component: Activity4Review,

      meta: { title: 'Activity 4 - Review' }

    }, {

      path: '/activity/4/completed',

      component: Activity4Completed,

      meta: { title: 'Activity 4 - Completed' }

    } ]

  }, {

    path: '/activity/5',

    component: Activity5,

    redirect: '/activity/5/intro',

    children: [ {

      path: '/activity/5/intro',

      component: Activity5Intro,

      meta: { title: 'Activity 5 - Introduction' }

    }, {
      
      path: '/activity/5/step/1',

      component: Activity5Step1,

      meta: { title: 'Activity 5 - Step 1' }

    }, {
      
      path: '/activity/5/step/2',

      component: Activity5Step2,

      meta: { title: 'Activity 5 - Step 2' }

    }, {

      path: '/activity/5/step/3',

      component: Activity5Step3,

      meta: { title: 'Activity 5 - Step 3' }

    }, {
      
      path: '/activity/5/step/4',

      component: Activity5Step4,

      meta: { title: 'Activity 5 - Step 4' }

    }, {

      path: '/activity/5/preview',

      component: Activity5Preview,

      meta: { title: 'Activity 5 - Review' }
      
    }, {

      path: '/activity/5/completed',

      component: Activity5Completed,

      meta: { title: 'Activity 5 - Completed' }

    } ]

  } ]
  
} );

router.beforeEach( to => {
  
  document.title = [ 'Lewis Mountain', to.meta.title ].join( ' - ' );

  window.scrollTo( 0, 0 );

} );

app.use( router );

app.mount( '#app' );
